// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-flex[data-v-a321b98c]{display:flex}.spacer[data-v-a321b98c]{width:20px}", ""]);
// Exports
module.exports = exports;
